export default __webpack_public_path__ + "static/media/005-instagram.19e4565a.svg";